import EA from 'helpers/init';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default EA.Methods.animServicesCards = ($this) => {
    const parent = $this;
    const animElement = parent.querySelectorAll('.anim-parallax');

    const mm = gsap.matchMedia();

    gsap.config({
        nullTargetWarn: false
    });

    animElement.forEach(element => {
        const moveDistance = element.getAttribute('data-parallax');

        mm.add('(min-width: 1000px)', () => {
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: parent,
                    start: 'top bottom',
                    end: '70% 20%',
                    scrub: 1.2,
                }
            });
    
            tl.from(element, {
                yPercent: -moveDistance,
                duration: 0.2,
                ease: 'power3.inOut',
            });
        });
    });
};